import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StepOneComponent } from './step-one/step-one.component';
import { NextStepComponent } from './next-step/next-step.component';

const routes: Routes = [
  { path: 'start', loadChildren: './start/start.module#StartModule' },
  { path: 'stepOne', component: StepOneComponent },
  { path: 'nextStep', component: NextStepComponent },

  { path: 'garden', loadChildren: './garden/garden.module#GardenModule' },
  { path: 'garden/q1', loadChildren: './garden/q1/q1.module#Q1Module' },
  { path: 'garden/q2', loadChildren: './garden/q2/q2.module#Q2Module' },
  {
    path: 'garden/q2Split',
    loadChildren: './garden/q2Split/q2Split.module#Q2SplitModule'
  },
  { path: 'garden/q3', loadChildren: './garden/q3/q3.module#Q3Module' },
  { path: 'garden/q4', loadChildren: './garden/q4/q4.module#Q4Module' },
  {
    path: 'garden/results',
    loadChildren: './garden/results/results.module#GardenResultsModule'
  },

  { path: 'balcony', loadChildren: './balcony/balcony.module#BalconyModule' },
  { path: 'balcony/q1', loadChildren: './balcony/q1/q1.module#Q1Module' },
  { path: 'balcony/q2', loadChildren: './balcony/q2/q2.module#Q2Module' },
  { path: 'balcony/q3', loadChildren: './balcony/q3/q3.module#Q3Module' },
  { path: 'balcony/q4', loadChildren: './balcony/q4/q4.module#Q4Module' },
  {
    path: 'balcony/results',
    loadChildren: './balcony/results/results.module#BalconyResultsModule'
  },

  {
    path: 'houseplant',
    loadChildren: './houseplant/houseplant.module#HouseplantModule'
  },
  { path: 'houseplant/q1', loadChildren: './houseplant/q1/q1.module#Q1Module' },
  { path: 'houseplant/q2', loadChildren: './houseplant/q2/q2.module#Q2Module' },
  { path: 'houseplant/q3', loadChildren: './houseplant/q3/q3.module#Q3Module' },
  { path: 'houseplant/q4', loadChildren: './houseplant/q4/q4.module#Q4Module' },
  {
    path: 'houseplant/results',
    loadChildren:
      './houseplant/results/houseplantResults.module#HouseplantResultsModule'
  },

  { path: 'bonsai', loadChildren: './bonsai/bonsai.module#BonsaiModule' },
  { path: 'bonsai/q1', loadChildren: './bonsai/q1/q1.module#Q1Module' },
  { path: 'bonsai/q2', loadChildren: './bonsai/q2/q2.module#Q2Module' },
  { path: 'bonsai/q3', loadChildren: './bonsai/q3/q3.module#Q3Module' },
  { path: 'bonsai/q4', loadChildren: './bonsai/q4/q4.module#Q4Module' },
  {
    path: 'bonsai/results',
    loadChildren: './bonsai/results/results.module#BonsaiResultsModule'
  },

  {
    path: 'agriculture',
    loadChildren: './agriculture/agriculture.module#AgricultureModule'
  },
  {
    path: 'agriculture/q1',
    loadChildren: './agriculture/q1/q1.module#Q1Module'
  },
  {
    path: 'agriculture/q2',
    loadChildren: './agriculture/q2/q2.module#Q2Module'
  },
  {
    path: 'agriculture/q3',
    loadChildren: './agriculture/q3/q3.module#Q3Module'
  },
  {
    path: 'agriculture/q4',
    loadChildren: './agriculture/q4/q4.module#Q4Module'
  },
  {
    path: 'agriculture/results',
    loadChildren:
      './agriculture/results/agricultureResults.module#AgricultureResultsModule'
  },

  {
    path: 'verticalGreening',
    loadChildren:
      './verticalGreening/verticalGreening.module#VerticalGreeningModule'
  },
  {
    path: 'verticalGreening/q1',
    loadChildren: './verticalGreening/q1/q1.module#Q1Module'
  },
  {
    path: 'verticalGreening/q2',
    loadChildren: './verticalGreening/q2/q2.module#Q2Module'
  },
  {
    path: 'verticalGreening/q3',
    loadChildren: './verticalGreening/q3/q3.module#Q3Module'
  },
  {
    path: 'verticalGreening/q4',
    loadChildren: './verticalGreening/q4/q4.module#Q4Module'
  },
  {
    path: 'verticalGreening/results',
    loadChildren:
      './verticalGreening/results/results.module#VerticalGreeningResultsModule'
  },

  { path: 'sensors', loadChildren: './sensors/sensors.module#SensorsModule' },
  { path: 'sensors/q1', loadChildren: './sensors/q1/q1.module#Q1Module' },
  { path: 'sensors/q2', loadChildren: './sensors/q2/q2.module#Q2Module' },
  { path: 'sensors/q3', loadChildren: './sensors/q3/q3.module#Q3Module' },
  { path: 'sensors/q4', loadChildren: './sensors/q4/q4.module#Q4Module' },
  {
    path: 'sensors/results',
    loadChildren: './sensors/results/results.module#SensorsResultsModule'
  },

  {
    path: 'roofGreening',
    loadChildren: './roofGreening/roofGreening.module#RoofGreeningModule'
  },
  {
    path: 'roofGreening/q1',
    loadChildren: './roofGreening/q1/q1.module#Q1Module'
  },
  {
    path: 'roofGreening/q2',
    loadChildren: './roofGreening/q2/q2.module#Q2Module'
  },
  {
    path: 'roofGreening/q2-split',
    loadChildren: './roofGreening/q2-split/q2-split.module#Q2SplitModule'
  },
  {
    path: 'roofGreening/q3',
    loadChildren: './roofGreening/q3/q3.module#Q3Module'
  },
  {
    path: 'roofGreening/q4',
    loadChildren: './roofGreening/q4/q4.module#Q4Module'
  },
  {
    path: 'roofGreening/results',
    loadChildren:
      './roofGreening/results/results.module#RoofGreeningResultsModule'
  },

  {
    path: 'specialRequests',
    loadChildren:
      './specialRequests/specialRequests.module#SpecialRequestsModule'
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/app.routing.ts